module.exports = __webpack_public_path__ + "static/media/delete.15fcc175.svg";